import { API_ENDPOINTS } from "../config/api.config";
import {
  BulkRoleRequest,
  BulkRoleResponse,
  Datasource,
  ListDatasourcesResponse,
  ListOrgsResponse,
  ListRolesResponse,
  OrgDetail,
  OrgUser,
  ProvisionOrgRequest,
  ProvisionOrgResponse,
  Role,
} from "../domain/types/admin.types";
import { http } from "./http";

export const adminService = {
  async listRoles(): Promise<Role[]> {
    const res = await http.get<ListRolesResponse>(API_ENDPOINTS.admin.roles);
    return res.roles;
  },

  async createRole(name: string, description?: string): Promise<Role> {
    return http.post<Role>(API_ENDPOINTS.admin.roles, { name, description: description ?? null });
  },

  async bulkManageRoles(req: BulkRoleRequest): Promise<BulkRoleResponse> {
    return http.post<BulkRoleResponse>(API_ENDPOINTS.admin.rolesBulk, req);
  },

  async listOrganisations(page: number, size: number, search?: string): Promise<ListOrgsResponse> {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (search) params.set("search", search);
    return http.get<ListOrgsResponse>(`${API_ENDPOINTS.admin.organisations}?${params}`);
  },

  async getOrganisationDetail(id: string): Promise<OrgDetail> {
    return http.get<OrgDetail>(API_ENDPOINTS.admin.organisationDetail(id));
  },

  async provisionOrganisation(req: ProvisionOrgRequest): Promise<ProvisionOrgResponse> {
    return http.post<ProvisionOrgResponse>(API_ENDPOINTS.admin.provisionOrg, req);
  },

  async deleteOrganisation(id: string): Promise<void> {
    return http.delete<void>(API_ENDPOINTS.admin.deleteOrg(id));
  },

  async inviteUserToOrg(orgId: string, email: string, roles: string[]): Promise<OrgUser> {
    return http.post<OrgUser>(API_ENDPOINTS.admin.inviteOrgUser(orgId), { email, roles });
  },

  async removeUserFromOrg(orgId: string, userId: string): Promise<void> {
    return http.delete<void>(API_ENDPOINTS.admin.removeMember(orgId, userId));
  },

  async listDatasources(): Promise<Datasource[]> {
    const res = await http.get<ListDatasourcesResponse>(API_ENDPOINTS.datasources.list);
    return res.datasources;
  },

  async linkDatasourceToOrg(datasourceId: string, orgId: string): Promise<void> {
    return http.post<void>(API_ENDPOINTS.datasources.linkOrg(datasourceId, orgId));
  },
};
